import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { advanceOnboarding, getOnboarding, listAgents } from './api'
import type { OnboardingSession } from './types'

export function onboardingSessionQueryKey(tenantId: string) {
  return ['onboarding', 'session', tenantId] as const
}

export function tenantAgentsQueryKey(tenantId: string) {
  return ['onboarding', 'agents', tenantId] as const
}

/** Sessao de onboarding do tenant (retomavel): a wizard deriva o passo atual daqui + de `tenant.status`. */
export function useOnboardingSession(tenantId: string | undefined) {
  return useQuery({
    queryKey: onboardingSessionQueryKey(tenantId ?? ''),
    queryFn: () => getOnboarding(tenantId ?? ''),
    enabled: tenantId !== undefined,
  })
}

/** Agentes do tenant. O onboarding usa o primeiro (o agente provisional) para abrir o Playground. */
export function useTenantAgents(tenantId: string | undefined) {
  return useQuery({
    queryKey: tenantAgentsQueryKey(tenantId ?? ''),
    queryFn: () => listAgents(tenantId ?? ''),
    enabled: tenantId !== undefined,
  })
}

/**
 * Persiste um avanco do onboarding e atualiza o cache da sessao, para que a wizard reflita o novo
 * estagio imediatamente (retomavel: a proxima montagem tambem re-hidrata do backend).
 */
export function useAdvanceOnboarding(tenantId: string | undefined) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: { stage?: string; firstValueReached?: boolean }) =>
      advanceOnboarding(tenantId ?? '', body),
    onSuccess: (session: OnboardingSession) => {
      if (tenantId !== undefined) {
        queryClient.setQueryData(onboardingSessionQueryKey(tenantId), session)
      }
    },
  })
}
